import script from "./AdminChargeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminChargeDialog.vue?vue&type=script&setup=true&lang=js"

import "./AdminChargeDialog.vue?vue&type=style&index=0&id=0df1440b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0df1440b"]])

export default __exports__